import mixpanel from 'mixpanel-browser';

import shopApi from '@services/shop';

/**
 * Complete onboarding for a single shop. Extracted from the onboarding page so
 * the branch logic is unit-testable independently of the heavy page state
 * machine (same rationale as `resolveDeepLinkStep`).
 *
 * Completion is per-shop, persisted on the shop row — not user-global Clerk
 * metadata — so a retailer can complete one location while another still needs
 * setup. If the shop is already complete (e.g. landed here via a stale /
 * cross-shop deep-link) we skip the write and just navigate to the dashboard,
 * rather than dead-ending on a silent no-op button.
 *
 * Navigates regardless of the write outcome — a failed status update must never
 * trap the user on the onboarding page.
 */
export const completeOnboarding = async ({ shop, navigate, shopPath, mutate }) => {
	if (!shop) return;

	if (shop.onboardingComplete) {
		navigate(shopPath('/'));
		return;
	}

	mixpanel.track('Unify onboarding completed', { distinct_id: shop.id });

	try {
		await shopApi.updateMyShop(shop.id, { onboardingComplete: true });
		await mutate?.();
	} catch (err) {
		console.error('Failed to update onboarding status:', err);
	}
	navigate(shopPath('/'));
};
